<div class="cms-navigation">
  <div class="cms-navigation__nav">
    <app-button buttonStyle="unstyled" (click)="router.navigate([''])">
      <app-icon [name]="ICONS.HOME"></app-icon>
    </app-button>
  </div>
  <div class="cms-navigation__avatar">
    <app-avatar></app-avatar>
  </div>
</div>
